// extracted by mini-css-extract-plugin
module.exports = {"bw":"styles_bw__2MKY7","btn":"styles_btn__2ynbP"};